module.exports = __webpack_public_path__ + "img/L12.9dedba9e.png";